// extracted by mini-css-extract-plugin
export default {"mainWrapper":"poc-detail_mainWrapper__wzGa5","headerWrapper":"poc-detail_headerWrapper__F8l1j","pocWrapper":"poc-detail_pocWrapper__HnLGh"};